// @ts-nocheck
import React from "react";
import Select, { SelectChevron } from "../../ReusableComponents/Select";
import { ReactComponent as ClockIcon } from "../../../assets/icons/clock-01.svg";

const LABELS = { local: "Local Time", asset: "Asset Time", UTC: "UTC" };

// The page's time zone, as a toolbar pill in the top bar. The pill is always labelled "Time Zone"; the list under it carries the choices and marks the current one. It applies to every chart, so with stacked charts — each carrying its own time range — it lives here rather than in any one chart's time-range dialog.
const TimeZonePicker = ({ timeZoneMode, hasAssetTimeZone, onTimeZoneChange, compact = false }) => {
  const options = [
    { value: "local", label: "Local Time" },
    ...(hasAssetTimeZone ? [{ value: "asset", label: "Asset Time" }] : []),
    { value: "UTC", label: "UTC" },
  ];
  return (
    <Select
      aria-label="Select time zone"
      title={`Time zone: ${LABELS[timeZoneMode] || "Local"}`}
      className={compact ? "eai-btn-toolbar-icon" : "eai-btn-toolbar"}
      trigger={
        <>
          <ClockIcon className="h-3.5 w-3.5 shrink-0 [&_path]:stroke-current" />
          {!compact && (
            <>
              <span>Time Zone</span>
              <SelectChevron className="h-3 w-3" />
            </>
          )}
        </>
      }
      value={timeZoneMode}
      onChange={(e) => onTimeZoneChange(e.target.value)}
      options={options}
    />
  );
};

export default TimeZonePicker;
